import React from 'react';
import { Target, Lightbulb, CheckCircle2 } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { visionMission } from '../utils/mockData';

export const VisionMissionSection = () => {
  return (
    <section className="py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto">
          <Card className="border border-gray-200 dark:border-gray-800 bg-white dark:bg-[#0F0F0F]">
            <CardContent className="p-8 space-y-4">
              <div className="w-12 h-12 rounded-lg bg-[#D32F2F]/10 flex items-center justify-center">
                <Target className="w-6 h-6 text-[#D32F2F]" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 dark:text-white">Visi Kami</h3>
              <p className="text-lg text-gray-600 dark:text-gray-400 leading-relaxed">
                {visionMission.vision}
              </p>
            </CardContent>
          </Card>

          <Card className="border border-gray-200 dark:border-gray-800 bg-white dark:bg-[#0F0F0F]">
            <CardContent className="p-8 space-y-4">
              <div className="w-12 h-12 rounded-lg bg-[#D32F2F]/10 flex items-center justify-center">
                <Lightbulb className="w-6 h-6 text-[#D32F2F]" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 dark:text-white">Misi Kami</h3>
              <ul className="space-y-3">
                {visionMission.mission.map((item, index) => (
                  <li key={index} className="flex items-start space-x-2">
                    <CheckCircle2 className="w-5 h-5 text-[#D32F2F] flex-shrink-0 mt-0.5" />
                    <span className="text-gray-600 dark:text-gray-400">{item}</span>
                  </li>
                ))}
              </ul>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};
